import React from "react";
import { motion } from "framer-motion";

// Staggered fade-up when entering viewport
export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true }) => {
  if (typeof window !== "undefined" && window.__SDRC_PRERENDER__) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for headings. Pass an array of lines.
export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={false}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold ${className}`}
  >
    <span className="h-px w-8 bg-brand-gold inline-block" />
    {children}
  </span>
);
